import { render, staticRenderFns } from "./ownerCommitteeDetailList.vue?vue&type=template&id=c1afe4e8&scoped=true"
import script from "./ownerCommitteeDetailList.vue?vue&type=script&lang=js"
export * from "./ownerCommitteeDetailList.vue?vue&type=script&lang=js"
import style0 from "./ownerCommitteeDetailList.vue?vue&type=style&index=0&id=c1afe4e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1afe4e8",
  null
  
)

export default component.exports